export const navIcons = {
    // auto
    namedinsured: 'fa-user',
    vehicles: 'fa-car',
    drivers: 'fa-users',
    priorinsurance: 'fa-id-card',
    newcoverages: 'fa-list-alt',
    carriermatches: 'fa-boxes',
    contactdetails: 'fa-folder-plus',
    drivervehicledetails: 'fa-folder-plus',
    policydetails: 'fa-folder-plus',
    checkout: 'fa-shopping-cart',
    confirmation: 'fa-clipboard-check',
    // home
    honamedinsured: 'fa-user',
    hopropertydetails: 'fa-home',
    hostructuredetails: 'fa-pencil-ruler',
    hooccupants: 'fa-users',
    hopriorinsurance: 'fa-id-card',
    honewcoverages: 'fa-list-alt',
    hocarriermatches: 'fa-boxes',
    hodwelling: 'fa-list-alt',
    homortgage: 'fa-home',
    hocoverage: 'fa-list-alt',
    hopolicydetails: 'fa-list-alt',
    hocheckout:'fa-shopping-cart',
    hoconfirmation: 'fa-clipboard-check',
    // condo
    conamedinsured: 'fa-user',
    copropertydetails: 'fa-hotel',
    costructuredetails: 'fa-pencil-ruler',
    cooccupants: 'fa-users',
    copriorinsurance: 'fa-id-card',
    conewcoverages: 'fa-list-alt',
    cocarriermatches: 'fa-boxes',
    // renters
    renamedinsured: 'fa-user',
    repropertydetails: 'fa-building',
    restructuredetails: 'fa-pencil-ruler',
    reoccupants: 'fa-users',
    repriorinsurance: 'fa-id-card',
    renewcoverages: 'fa-list-alt',
    recarriermatches: 'fa-boxes',
}

export const routeDictionary = {
    renamedinsured: '/renters/name-insured',
    repropertydetails: '/renters/property-details',
    reoccupants: '/renters/occupants',
    repriorinsurance: '/renters/prior-insurance',
    renewcoverages: '/renters/coverages',
    recarriermatches: '/renters/carrier-matches',
    conamedinsured: '/condo/name-insured',
    copropertydetails: '/condo/property-details',
    costructuredetails: '/condo/structure-details',
    cooccupants: '/condo/occupants',
    copriorinsurance: '/condo/prior-insurance',
    conewcoverages: '/condo/coverages',
    cocarriermatches: '/condo/carrier-matches',
    hostructuredetails: '/home/structure-details',
    hopropertydetails: '/home/property-details',
    hopriorinsurance: '/home/prior-insurance',
    hooccupants: '/home/occupants',
    honewcoverages: '/home/coverages',
    honamedinsured: '/home/name-insured',
    hocarriermatches: '/home/carrier-matches',
    hodwelling: '/home/dwelling',
    homortgage: '/home/mortgage',
    hocoverage: '/home/coverage',
    hocheckout: '/home/checkout',
    hoconfirmation:'/home/confirmation',
    horatecall2details: '/home/dwelling',
    drivers: '/auto/drivers',
    namedinsured: '/auto/name-insured',
    vehicles: '/auto/vehicles',
    priorinsurance: '/auto/prior-insurance',
    newcoverages: '/auto/coverage',
    carriermatches: '/auto/carrier-matches',
    progcontactdetails: '/auto/prog/rc2-contact-details',
    progdrivervehicledetails: '/auto/prog/rc2-driver-vehicle-details',
    progpolicydetails: '/auto/prog//rc2-policy-details',
    progcheckout: '/auto/prog/checkout',
    progconfirmation: '/auto/prog/confirmation',
    safecontactdetails: '/auto/safeco/rc2-contact-details',
    safedrivervehicledetails: '/auto/safeco/rc2-driver-vehicle-details',
    safepolicydetails: '/auto/safeco/rc2-policy-details',
    safecheckout: '/auto/safeco/checkout',
    safeconfirmation: '/auto/safeco/confirmation',
    nwidcontactdetails: '/auto/nationwide/rc2-contact-details',
    nwiddrivervehicledetails: '/auto/nationwide/rc2-driver-vehicle-details',
    nwidpolicydetails: '/auto/nationwide/rc2-policy-details',
    nwidcheckout: '/auto/nationwide/checkout',
    nwidconfirmation: '/auto/nationwide/confirmation',
    branpolicydetails: '/auto/branch/rc2-policy-details',
    branhopolicydetails: '/home/branch/rc2-policy-details',
    hopolicydetails: '/home/hopolicydetails',
    brancheckout: '/auto/branch/checkout',
    branconfirmation: '/auto/branch/confirmation',
    kempercontactdetails:'/auto/kemper/rc2-contact-details',
    kemperdrivervehicledetails: '/auto/kemper/rc2-driver-vehicle-details',
    kemperpolicydetails: '/auto/kemper/rc2-policy-details',
    kempercheckout: '/auto/kemper/checkout',
    kemperconfirmation: '/auto/kemper/confirmation',
  };

  export const navStatuses = {
    ActiveFirstTime: {
        itemTitle: 'Page Incomplete',
        isComplete: null,
        buttonStyles: 'activeTab',
    },
    InactiveFirstTime: {
        itemTitle: 'Page Incomplete',
        isComplete: null,
    },
    InactiveIncomplete: {
        itemTitle: 'Page Incomplete',
        isComplete: false,
    },
    ActiveIncomplete: {
        itemTitle: 'Page Incomplete',
        isComplete: false,
        buttonStyles: 'activeTab',
    },
    InactiveComplete: {
        itemTitle: 'Page Complete',
        isComplete: true,
    },
    ActiveComplete: {
        itemTitle: 'Page Complete',
        isComplete: true,
        buttonStyles: 'activeTab',
    },
    Disabled: {
        itemTitle: 'Page Disabled',
        isComplete: null,
        buttonStyles: 'disabled',
    },
  };

  export const carrierDetailsArray = {
    nwid : {
        carrier_id: 126,
        carrier_name: 'Nationwide Insurance',
    },
    prog : {
        carrier_id: 3,
        carrier_name: 'Progressive',
    },
    bran : {
        carrier_id: 171,
        carrier_name: 'Branch',
    }
  };

  export const pendingRC2FlowCarrierArr = {
    'home' : ['Travelers'],
    'auto' : ['Travelers','Elephant']
  };
  


//////////////////
// WEBPACK FOOTER
// ./config/dictionaries/product-navigation.js
// module id = null
// module chunks = 